import { Event } from '@/clients/utoniq-core/schema'
import { dayjs } from '@/lib/dayjs'

/**
 * filter hidden item of array
 * @param data
 */
export function filterHiddenItem<T>(data: (T & { hidden?: boolean })[]): T[] {
  return data.filter(({ hidden }) => !hidden)
}

/**
 * build event date array
 * @param event
 * @param {string} month
 */
export function buildEventDateArray(
  event: Pick<Event, 'startedAt' | 'endedAt' | 'closeDate'>,
  month: string
): string[] {
  const dateArray: string[] = []
  const startDayInMonth = dayjs(month, 'YYYYMM')
    .startOf('months')
    .startOf('day')
  const daysInMonth = startDayInMonth.daysInMonth()

  Array.from({ length: daysInMonth }).forEach((_, index) => {
    const date = startDayInMonth.add(index, 'd')
    const dateFormated = +date.format('YYYYMMDD')
    const closeDate = event.closeDate?.map(
      closeDate => +dayjs(closeDate).format('YYYYMMDD')
    )
    const startedAtFormated = +dayjs(event.startedAt).format('YYYYMMDD')
    const endedAtFormated = +dayjs(event.endedAt).format('YYYYMMDD')

    if (closeDate?.length && closeDate.includes(dateFormated)) {
      return
    }

    if (!event.startedAt && !event.endedAt) {
      return dateArray.push(date.format('YYYY/MM/DD'))
    }
    if (
      event.startedAt &&
      !event.endedAt &&
      dateFormated >= startedAtFormated
    ) {
      return dateArray.push(date.format('YYYY/MM/DD'))
    }
    if (event.endedAt && !event.startedAt && dateFormated <= endedAtFormated) {
      return dateArray.push(date.format('YYYY/MM/DD'))
    }
    if (
      event.startedAt &&
      event.endedAt &&
      endedAtFormated >= dateFormated &&
      startedAtFormated <= dateFormated
    ) {
      return dateArray.push(date.format('YYYY/MM/DD'))
    }
  })

  return dateArray
}
